import SettingBase from '../settings/util/SettingBase'

class BranchFundingSourceHolidayController extends SettingBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.acl = {};
        this.hasACL = {};
        this.id = 'branch-funding-source-holiday';
        this.$state = $state;
        this.hasACL = {};
    }

    $onInit() {
        super.$onInit()
        for (let key in this.acl['setting-branch-funding-source-holiday']) {
            this.hasACL[this.acl['setting-branch-funding-source-holiday'][key]] = true;
        }
    }
}

export default BranchFundingSourceHolidayController;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/branch_funding_source_holiday.controller.js